/*eslint-disable */
import pdfViewer from './pdf-viewer';
import {
  mapGetters,
  } from 'vuex';
  import {
    bus
  } from '@/main';
export default {
  name: 'payment-history',
  components: {
   'pdf-viewer' : pdfViewer,
  },
  props: [],
  data () {
    return {
      paymentHistoryData:null,
      paymentHistoryResults:[],
      selfUserInfoState:null,
      selfUserId:'',
      payment_delay_status:null,
      pdfViewerPopup:false,
      pdfViewerUrl:'',
      pdfViewerFileName:'',
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
      'getMeetingListGetters',,
      'isConditionalListOfAllUsersGetters'
    ]),
    getSelfUserInfo(){
      this.selfUserInfoState = this.$store.getters.acUserDetailsStateGetters.data;
      return
    },
  },
  mounted () {
    this.getSelfUserInfo
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    this.postPaymentHistoryMethod();
    bus.$on('pdfViewerPopupBus', (data) => {
      this.pdfViewerPopup = data;
    });
  },
  methods: {
    pdfViewerFun(url){
      this.pdfViewerFileName = 'invoice.pdf'
      this.pdfViewerUrl = url
      this.pdfViewerPopup = true
      document.body.classList.add('pdf_view_actv')
    },
    postPaymentHistoryMethod(){
      let data = {
        id:this.selfUserId
      }
      this.$store.dispatch('postPaymentHistoryFunc', data).then((res) => {
        this.paymentHistoryData = res
        this.paymentHistoryResults = this.paymentHistoryData.data
      })
    }
  },
  watch:{
    getSelfUserInfo(){
      return this.$store.getters.acUserDetailsStateGetters;
    }
  },
  beforeRouteLeave: function (to, from, next) {
    this.$store.dispatch('getAcUserDetailsFun')
    next();
  },
}